export default __webpack_public_path__ + "static/media/game_starter.7a57414e.mp3";